import Input from "../../../../../../../components/Input";
import useImmolizedStore from "../../store/useStore";

export default function Row5() {
  const { defaultValues, listUsers } = useImmolizedStore();
  const { saveDataOfField } = useImmolizedStore();
  return (
    <>
      <div className="box-row">
        {defaultValues?.status === "Em uso" && (
          <Input
            name="responsible"
            label="Responsável"
            placeholder="Responsável"
            value={defaultValues?.responsible}
            setValue={(event) => saveDataOfField(event.target)}
          />
        )}
        {defaultValues?.status !== "Em uso" && defaultValues?.status !== "Disponível" && defaultValues?.status !== "Em manutenção" && (
          <Input
            name="observation"
            label="Observação"
            placeholder="Digite uma observação"
            value={defaultValues?.observation}
            setValue={(event) => saveDataOfField(event.target)}
          />
        )}
      </div>
    </>
  );
}
